import styled from 'styled-components';

import { primitive } from 'styles/constants/primitives';

export interface IListable {
  first: boolean;
  last: boolean;
  shouldRenderDefaultBackground?: boolean;
}

export const Section = styled.section<IListable>`
  display: block;
  background-color: ${p =>
    p.shouldRenderDefaultBackground ? p.theme.token('background-default') : 'transparent'};
  padding: ${primitive.$spacing4} 0;
  /* HACK: The hero has too much padding on the bottom */
  /* TODO: change to 2rem */
  padding-block-start: ${({ first }) => (first ? '0' : primitive.$spacing4)};
  padding-block-end: ${({ last }) => (last ? primitive.$spacing7 : primitive.$spacing4)};

  ${Styles.desktop} {
    padding-block-start: ${({ first }: IListable) =>
      first ? primitive.$spacing7 : primitive.$spacing4};
    padding-block-end: ${({ last }: IListable) =>
      last ? primitive.$spacing7 : primitive.$spacing4};
  }
`;

interface ISpacer {
  $isSmall: boolean;
}
export const Spacer = styled.div<ISpacer>`
  height: 0;
  ${Styles.desktopLarge} {
    height: ${(p: ISpacer) => (p.$isSmall ? '2rem' : '110px')};
  }
`;
